import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SiteLockGate } from "./components/SiteLockGate";
import { UsageTracker } from "./components/UsageTracker";
import { DropCountdown } from "./components/DropCountdown";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Events from "./pages/Events";
import Artists from "./pages/Artists";
import ArtistStore from "./pages/ArtistStore";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Lookbook from "./pages/Lookbook";
import Checkout from "./pages/Checkout";
import ArtistDetail from "./pages/ArtistDetail";
import Tickets from "./pages/Tickets";
import PortalLogin from "./pages/PortalLogin";
import VerifyEmail from "./pages/VerifyEmail";
import CustomerPortal from "./pages/CustomerPortal";
import HelpPage from "./pages/HelpPage";
import ArtistDashboard from "./pages/ArtistDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import CheckoutSuccess from "./pages/CheckoutSuccess";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen bg-kult-black text-white font-body">
      <AuthProvider>
        <AppProvider>
          <SiteProvider>
            <BrowserRouter>
              <ScrollToTop />
              <UsageTracker />
              <SiteLockGate>
                <DropCountdown />
                <Header />
                <CartDrawer />
                <main>
                  <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/artists" element={<Artists />} />
                  <Route path="/artists/:slug" element={<ArtistDetail />} />
                  <Route path="/store/:slug" element={<ArtistStore />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/lookbook" element={<Lookbook />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/tickets" element={<Tickets />} />
                  <Route path="/tickets/success" element={<CheckoutSuccess />} />
                  <Route path="/portal/login" element={<PortalLogin />} />
                  <Route path="/auth/verify" element={<VerifyEmail />} />
                  <Route
                    path="/portal/customer"
                    element={
                      <ProtectedRoute role="customer">
                        <CustomerPortal />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/portal/artist"
                    element={
                      <ProtectedRoute role="artist">
                        <ArtistDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/portal/admin"
                    element={
                      <ProtectedRoute role="admin">
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/help" element={<HelpPage page="faq" />} />
                  <Route path="/help/faq" element={<HelpPage page="faq" />} />
                  <Route path="/help/delivery" element={<HelpPage page="delivery" />} />
                  <Route path="/help/contact" element={<HelpPage page="contact" />} />
                  <Route path="/contact" element={<HelpPage page="contact" />} />
                </Routes>
              </main>
              <Footer />
              </SiteLockGate>
              <Toaster />
            </BrowserRouter>
          </SiteProvider>
        </AppProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
